import "@/App.css";
import "@/lib/theme";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { AccessibilityProvider } from "@/contexts/AccessibilityContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import SessionPlanner from "@/pages/SessionPlanner";
import MySessions from "@/pages/MySessions";
import PrayerLibrary from "@/pages/PrayerLibrary";
import SharedSession from "@/pages/SharedSession";
import FollowSession from "@/pages/FollowSession";
import Settings from "@/pages/Settings";
import LibraryAdmin from "@/pages/LibraryAdmin";
import MyMinistry from "@/pages/MyMinistry";
import OrganizationsAdmin from "@/pages/OrganizationsAdmin";
import AuthCallback from "@/pages/AuthCallback";
import JoinMinistry from "@/pages/JoinMinistry";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback provider="google" />;
  return (
          <Routes>
            <Route path="/auth/complete" element={<AuthCallback provider="apple" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/share/:token" element={<SharedSession />} />
            <Route path="/follow/:token" element={<FollowSession />} />
            <Route path="/join/:token" element={<JoinMinistry />} />
            <Route path="/sessions" element={<ProtectedRoute><MySessions /></ProtectedRoute>} />
            <Route path="/library" element={<ProtectedRoute><PrayerLibrary /></ProtectedRoute>} />
            <Route path="/admin/library" element={<ProtectedRoute><LibraryAdmin /></ProtectedRoute>} />
            <Route path="/admin/organizations" element={<ProtectedRoute><OrganizationsAdmin /></ProtectedRoute>} />
            <Route path="/ministry" element={<ProtectedRoute><MyMinistry /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/planner/:sessionId" element={<ProtectedRoute><SessionPlanner /></ProtectedRoute>} />
            <Route path="/" element={<Navigate to="/sessions" replace />} />
          </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AccessibilityProvider>
        <AuthProvider>
          <Toaster position="top-right" />
          <AppRoutes />
        </AuthProvider>
        </AccessibilityProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
